import { Button, Card, Container, Step, StepLabel, Stepper, Typography } from '@material-ui/core';
import StepConnector from '@material-ui/core/StepConnector';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { Theme } from '@material-ui/core/styles';
import Looks3Icon from '@material-ui/icons/Looks3';
import Looks4Icon from '@material-ui/icons/Looks4';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import LooksTwoIcon from '@material-ui/icons/LooksTwo';
import { createStyles, makeStyles, withStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { FC } from 'react';
import Category from '../icons/Category';
import CategorySectionProcess from './CategorySectionProcess';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      height: '150px',
      padding: '10px'
    },
    button: {
      marginRight: theme.spacing(1)
    },
    completed: {
      display: 'inline-block'
    },
    instructions: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
      fontWeight: theme.typography.fontWeightBold,
      align: 'center'
    }
  })
);

const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22
  },
  active: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)'
    }
  },
  completed: {
    '& $line': {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)'
    }
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1
  }
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 50,
    height: 50,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  active: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
  },
  completed: {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)'
  }
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <LooksOneIcon />,
    2: <LooksTwoIcon />,
    3: <Looks3Icon />,
    4: <Looks4Icon />
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

function getSteps() {
  return ['', '', '', ''];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return 'Step 1: Visit nearest Provincial offices of ZIMTA to process claim, or do an online Claim for self services...';
    case 1:
      return 'Step 2: Fill in Claim forms together with Mortual Release forms or Burial Order.';
    case 2:
      return 'Step 3: The Underwriting department will determine the services that you quality for based on your selected assurance.';
    case 3:
      return 'Step 4: Once approved, the full Funeral Services will be provided.';
    default:
      return 'Unknown step';
  }
}

export default function Section10() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const steps = getSteps();

  const totalSteps = () => steps.length;

  const completedSteps = () => Object.keys(completed).length;

  // const isLastStep = () => {
  //   return activeStep === totalSteps() - 1;
  // };

  const allStepsCompleted = () => completedSteps() === totalSteps();

  // const handleNext = () => {
  //   const newActiveStep =
  //     isLastStep() && !allStepsCompleted()
  //       ? // It's the last step, but not all steps have been completed,
  //       // find the first step that has been completed
  //       steps.findIndex((step, i) => !(i in completed))
  //       : activeStep + 1;
  //   setActiveStep(newActiveStep);
  // };

  // const handleBack = () => {
  //   setActiveStep((prevActiveStep) => prevActiveStep - 1);
  // };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  // const handleComplete = () => {
  //   const newCompleted = completed;
  //   newCompleted[activeStep] = true;
  //   setCompleted(newCompleted);
  //   handleNext();
  // };

  const handleReset = () => {
    setActiveStep(0);
    // setCompleted({});
  };

  return (
    <Container sx={{ mb: '70px' }}>
      <CategorySectionProcess
        title="How the Claim Process Works..."
        icon={<Category color="primary" />}
        seeMoreLink="#"
      />

      <Card className={classes.root} sx={{ mt: '4px' }}>
        <Stepper nonLinear activeStep={activeStep} connector={<ColorlibConnector />}>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel StepIconComponent={ColorlibStepIcon} onClick={handleStep(index)}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        <div>
          {allStepsCompleted() ? (
            <div>
              <Typography className={classes.instructions}>
                All steps completed - you&apos;re finished
              </Typography>
              <Button onClick={handleReset}>Reset</Button>
            </div>
          ) : (
            <div>
              <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
            </div>
          )}
        </div>
      </Card>
    </Container>
  );
}
